import createIcon from '@/lib/create-icon'

const ChatIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M4.83333 6.08333H13.1667M4.83333 9.41667H9.83333M1.5 4.83333C1.5 2.99238 2.99238 1.5 4.83333 1.5H13.1667C15.0076 1.5 16.5 2.99238 16.5 4.83333V10.6667C16.5 12.5076 15.0076 14 13.1667 14H7.83333L4.83333 16.5V14C2.99238 14 1.5 12.5076 1.5 10.6667V4.83333Z'
      stroke='currentColor'
      strokeWidth='1.29505'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'ChatIcon'
)

export default ChatIcon
